/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const welcomeDemoContent = [
  { type: 'heading', level: 1, text: 'Where your notes turn into action' },
  {
    type: 'paragraph',
    text: 'Everything you add here becomes part of a workspace that understands, organizes, and helps you move forward.',
  },
  { type: 'heading', level: 2, text: 'What you can do' },
  {
    type: 'bullets',
    items: [
      'Capture ideas in the moment',
      'Link notes to meetings and briefings',
      'Let Sia summarize and suggest next steps',
    ],
  },
]
